<template>
	<div class="col-12 col-md-6 col-lg-4 mb-4">
		<div class="tablinx-link-item">
			<router-link v-if="post.metaInput" :to="`/post/?id=${post._id}`" class="d-block">
				<img
					:src="post.metaInput.image"
					alt="" class="d-block w-100">
				<div class="link-item-content link-item-bg p-3">
					<div v-if="post.authorContent?.length" class="description d-flex align-items-center mb-2">
						<p class="mb-0">{{ post.authorContent }}</p>
					</div>
					<p class="title mb-2">
						<b>{{ post.title }}</b>
					</p>

					<div class="description mb-0">
						<small><p>{{ post.description }}</p>
						</small>
					</div>

					<PostCardFooter :post="post" :currentUserId="currentUserId"/>
				</div>
			</router-link>
			<router-link :to="`/post/?id=${post._id}`" v-else class="d-block">
				<img
					v-if="post.image"
					:src="post.image"
					alt="" class="d-block w-100">
				<div class="link-item-content link-item-bg p-3">
					<div v-if="post.authorContent?.length" class="description d-flex align-items-center mb-2">
						<p class="mb-0">{{ post.authorContent }}</p>
					</div>
					<PostCardFooter :post="post" :currentUserId="currentUserId"/>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { PropType } from 'vue/dist/vue';
import PostCardFooter from '@/components/PostCard/PostCardFooter.vue';

interface Post {
	_id: number,
	author: {
		_id: number,
		wpId: number,
		avatar: string
		firstName: string,
		lastName: string
	}
	title?: string
	description?: string
	authorContent?: string,
	metaInput?: {
		image: string,
		sourceUrl: string
	}
	created_at: string
	image?: string
}

export default defineComponent({
	name: 'PostCard',
	components: { PostCardFooter },
	props: {
		post: {
			type: Object as PropType<Post>,
			required: true
		},
		currentUserId: {
			required: true
		}
	},
	data(){
		return {}
	},
	mounted(){},
	methods: {},
})
</script>
